import React, { FormEventHandler, FunctionComponent, useState } from 'react'
import { Input } from '../form'
import style from './enterVehicleCodeForm.css'

export type Props = {
    onSubmit: Function
    title: string
    inputLabel: string
    inputPlaceholder: string
    inputDataTestId: string
    submitCodeButtonDataTestId: string
    submitCodeButtonLabel: string
    validationError: string
    requiredCodeLength: number
    codeInfoTitle: string
    codeInfoDescription: string
}

const EnterVehicleCodeForm: FunctionComponent<Props> = (props) => {
    const {
        onSubmit,
        title,
        inputLabel,
        inputPlaceholder,
        inputDataTestId,
        submitCodeButtonDataTestId,
        submitCodeButtonLabel,
        validationError,
        requiredCodeLength,
        codeInfoTitle,
        codeInfoDescription,
    } = props
    const [code, setCode] = useState('')
    const [error, setError] = useState('')

    const codeChange = (value: string): void => {
        const formatted = value.toUpperCase().trim()
        setCode(formatted)
        if (formatted.length === 0 || formatted.length === requiredCodeLength) {
            setError('')
        }
    }

    const submitHandler: FormEventHandler = (event) => {
        event.preventDefault()

        if (code.length !== requiredCodeLength) {
            setError(validationError)
            return
        }
        onSubmit(code)
        setCode('')
    }

    return (
        <div className={style.container}>
            <h2 className={style.title}>{title}</h2>
            <form onSubmit={submitHandler} className={style.enterCodeForm}>
                <label className={style.label}>{inputLabel}</label>
                <div className={style.actionArea}>
                    <Input
                        value={code}
                        onChange={(event) => codeChange(event.target.value)}
                        className={error ? `${style.input} ${style.inputError}` : style.input}
                        placeholder={inputPlaceholder}
                        required
                        data-testid={inputDataTestId}
                    />
                    <button
                        className={style.button}
                        type="submit"
                        data-testid={submitCodeButtonDataTestId}
                    >
                        {submitCodeButtonLabel}
                    </button>
                </div>
                {error && <div className={style.error}>{error}</div>}
            </form>
            <div className={style.info}>
                <h4 className={style.infoTitle}>{codeInfoTitle}</h4>
                <p className={style.infoDescription}>{codeInfoDescription}</p>
            </div>
        </div>
    )
}

export default EnterVehicleCodeForm
